import { render, staticRenderFns } from "./haier.vue?vue&type=template&id=1fa03c9a&"
import script from "./haier.vue?vue&type=script&lang=js&"
export * from "./haier.vue?vue&type=script&lang=js&"
import style0 from "./haier.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports